// extracted by mini-css-extract-plugin
export default {"mCard":"cF-z","image":"dF-z","imageNoBackground":"eF-z","fullWidth":"fF-z"};